module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "npower-append-target-modal"
  }, [_c('modal', {
    ref: "modal",
    attrs: {
      "autoWidth": "",
      "closeButton": ""
    },
    on: {
      "closed": _vm.onClose
    }
  }, [_c('append-n-power-form', {
    ref: "form",
    attrs: {
      "title": "Append Audience Segments"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c71b8ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/NPowerAppendTargetModal.vue
// module id = 1888
// module chunks = 0